import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface PublicationDateProps {
  publicationDate: Date;
}

const WEEKDAYS = 7;

const PublicationDate: React.FC<PublicationDateProps> = (props) => {
  const { t } = useTranslation();

  const { publicationDate } = props;

  const renderPublicationDate = useMemo(() => {
    const translationBase = 'components.article_metadata.publication_date';
    const timeSincePublicationDate = new Date().getTime() - publicationDate.getTime();
    const daysSincePublicationDate = Math.floor(timeSincePublicationDate / (24 * 60 * 60 * 1000));

    // Publication date is today.
    if (daysSincePublicationDate === 0) {
      return t(`${translationBase}_today`);
    }

    // Publication date is within one week.
    if (daysSincePublicationDate < WEEKDAYS) {
      // Days variable has to be negative to trigger i18next' past tense.
      return t(`${translationBase}_relative`, { days: (daysSincePublicationDate * -1) });
    }

    return t(`${translationBase}`, {
      publicationDate,
      formatParams: {
        publicationDate: {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        },
      },
    });
  }, [publicationDate, t]);

  return (
    <time className="PublicationDate" dateTime={publicationDate.toUTCString()}>
      {renderPublicationDate}
    </time>
  );
};

export default PublicationDate;
